import { render, staticRenderFns } from "./ContractCreationForm.vue?vue&type=template&id=b6cf2c7a&"
import script from "./ContractCreationForm.vue?vue&type=script&lang=js&"
export * from "./ContractCreationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports